module.exports = __webpack_public_path__ + "static/media/sign_up_french.e403d07d.jpg";